import * as React from 'react';

import { GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { HealLocations } from '../../config/healhq';

const pinPath =
  'M11.5,27 L3.94257703,17.1836158 C1.35247432,13.7937853 1.35247432,9.09745763 3.94257703,5.70762712 C5.75210084,3.34180791 ' +
  '8.51960784,2 11.5,2 C14.4803922,2 17.2478992,3.34180791 19.057423,5.70762712 C21.6475257,9.09745763 21.6475257,13.7937853 19.057423,17.1836158 L11.5,27 Z';

export function pinSymbol(color?: string, strokeColor?: string) {
  return {
    path: pinPath,
    fillColor: color || '#ef426f',
    fillOpacity: 1,
    strokeColor: strokeColor || '#ef426f',
    strokeWeight: 2,
    scale: 1,
  };
}

export function diamondSymbol(color: string) {
  return {
    path: 'M -8,0 0,-8 8,0 0,8 z',
    fillColor: color || '#ef426f',
    fillOpacity: 1,
    strokeColor: color || '#ef426f',
  };
}

export interface Point extends google.maps.LatLngLiteral {
  selected?: boolean;
  toolTip?: string;
  icon?: any;
  onClick?: () => void;
}

export const HealHqMap = ({ center, points, height }: { center: google.maps.LatLngLiteral; points: Point[]; height: number }) => {
  const updatedPoints = points.map((p) => ({
    icon: pinSymbol('#00bed4', '#00bed4'),
    ...p,
  }));

  const options: google.maps.MapOptions = {
    maxZoom: 16,
    minZoom: 8,
    scrollwheel: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
  };

  return (
    <GoogleMap mapContainerStyle={{ height }} zoom={12} center={center} options={options}>
      {updatedPoints.map((p, i) => (
        <Marker key={i} position={p} icon={p.icon} onClick={p.onClick}>
          {p.toolTip && (
            <InfoWindow position={p} options={{ disableAutoPan: true }}>
              <div>{p.toolTip}</div>
            </InfoWindow>
          )}
        </Marker>
      ))}
      {HealLocations.map((hq) => (
        <Marker key={hq.name} position={hq.position} icon={pinSymbol()}>
          <InfoWindow position={hq.position} options={{ disableAutoPan: true }}>
            <div>{`Heal: ${hq.name}`}</div>
          </InfoWindow>
        </Marker>
      ))}
    </GoogleMap>
  );
};
